/**
 * 패스키 provider 별 아이콘 매핑 (Figma OfficePassword v4 — node 924:601/623/696/772/760).
 *
 * aaguid → provider 이름 (services/passkey/aaguid_map) → 아이콘 svg.
 * 디자인에 정의된 4종(iCloud Keychain, Google Password Manager, Chrome, Windows Hello)
 * 외 provider 및 NULL/미매핑 aaguid 는 default(지문) 아이콘.
 *
 * passkeyHelpers.js 와 분리한 이유: passkeyHelpers 단위 테스트가 node 환경에서 돌아
 * svg import 가 들어가면 transform 에러로 깨진다. 에셋 의존 모듈은 이 파일에만 둘 것.
 */
import aaguidToProvider from 'services/passkey/aaguid_map'

import chromeIcon from '@/assets/images/passkey/icon-passkey-chrome-24.svg'
import defaultIcon from '@/assets/images/passkey/icon-passkey-default-24.svg'
import googlePasswordManagerIcon from '@/assets/images/passkey/icon-passkey-google-password-manager-24.svg'
import icloudKeychainIcon from '@/assets/images/passkey/icon-passkey-icloud-keychain-24.svg'
import windowsHelloIcon from '@/assets/images/passkey/icon-passkey-windows-hello-24.svg'

const PROVIDER_ICON_MAP = {
  'Apple Passwords': icloudKeychainIcon,
  'iCloud Keychain (Managed)': icloudKeychainIcon,
  'Google Password Manager': googlePasswordManagerIcon,
  'Chrome on Mac': chromeIcon,
  'Chromium Browser': chromeIcon,
  'Windows Hello': windowsHelloIcon,
}

export function getPasskeyProviderIcon(aaguid) {
  const provider = aaguidToProvider(aaguid)
  return PROVIDER_ICON_MAP[provider] || defaultIcon
}

export default getPasskeyProviderIcon
